// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607211434/js/" + chunkId + "." + {"44":"639d820d","225":"8efba62d","481":"c8b57333","486":"dfe79b15","770":"5b53e0d7"}[chunkId] + ".0.7002343347648261.chunk.js";
};